import * as SelectPrimitive from "@radix-ui/react-select";

const Select = SelectPrimitive.Root;

export { Select };
